import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';

const AllUsers = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [walletUpdates, setWalletUpdates] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState(''); // New state for search query
  const { token } = useAuth();

  const USERS_PER_PAGE = 15;

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/users/`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUsers(response.data);
        setTotalPages(Math.ceil(response.data.length / USERS_PER_PAGE));
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, [token]);

  const handleInputChange = (userId, value) => {
    setWalletUpdates({ ...walletUpdates, [userId]: value });
  };

  const handleUpdateWallet = async (userId) => {
    try {
      const amount = parseFloat(walletUpdates[userId] || 0);
      if (isNaN(amount)) {
        alert('Please enter a valid number');
        return;
      }

      const response = await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/users/wallet/${userId}`,
        { amount },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      alert(response.data.message);

      setUsers((prevUsers) =>
        prevUsers.map((user) =>
          user._id === userId ? { ...user, wallet: response.data.wallet } : user
        )
      );
    } catch (err) {
      alert(`Error updating wallet: ${err.message}`);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Filter users based on the search query
  const filteredUsers = users.filter((user) =>
    user.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * USERS_PER_PAGE,
    currentPage * USERS_PER_PAGE
  );

  if (loading) return <p>Loading users...</p>;
  if (error) return <p>Error fetching users: {error}</p>;

  return (
    <div className="flex flex-col md:flex-row">
      {/* Sidebar */}
      <Sidebar />

      {/* Content */}
      <div className="flex-1 bg-gray-50 p-4 md:p-6">
        <h1 className="text-lg md:text-2xl font-bold text-gray-700 mb-4">All Users</h1>

        {/* Search Bar */}
        <div className="mb-4">
          <input
            type="text"
            placeholder="Search by email"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full p-2 border rounded-lg"
          />
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full bg-white rounded-lg shadow-md">
            <thead className="bg-gray-200">
              <tr>
                <th className="px-4 py-2 text-left text-gray-700">Email</th>
                <th className="px-4 py-2 text-left text-gray-700">Full Name</th>
                <th className="px-4 py-2 text-left text-gray-700">Wallet</th>
                <th className="px-4 py-2 text-left text-gray-700">Update Wallet</th>
              </tr>
            </thead>
            <tbody>
              {paginatedUsers.map((user) => (
                <tr key={user._id} className="hover:bg-gray-50 border-b">
                  <td className="px-4 py-2 text-gray-700 whitespace-nowrap">{user.email}</td>
                  <td className="px-4 py-2 text-gray-700 whitespace-nowrap">{user.fullName}</td>
                  <td className="px-4 py-2 text-gray-700 whitespace-nowrap">{user.wallet}</td>
                  <td className="px-4 py-2 text-gray-700">
                    <div className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-2">
                      <input
                        type="number"
                        placeholder="Enter amount"
                        value={walletUpdates[user._id] || ''}
                        onChange={(e) => handleInputChange(user._id, e.target.value)}
                        className="p-2 border rounded-lg w-full md:w-auto"
                      />
                      <button
                        onClick={() => handleUpdateWallet(user._id)}
                        className="px-4 py-2 bg-primary text-black rounded-lg hover:bg-yellow-500 hover:text-black"
                      >
                        Update
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex justify-center mt-4 flex-wrap">
          {Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => (
            <button
              key={page}
              onClick={() => handlePageChange(page)}
              className={`px-4 py-2 mx-1 mb-2 rounded-lg ${currentPage === page ? 'bg-primary text-black' : 'bg-gray-200 text-gray-700'
                }`}
            >
              {page}
            </button>
          ))}
        </div>
      </div>
    </div>
  );

};

export default AllUsers;
